var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "my-account" }, [
    _c("div", { staticClass: "my-account-frame" }, [
      !_vm.isLoggedIn
        ? _c(
            "div",
            {
              staticClass: "hAcc collapsed",
              attrs: {
                role: "button",
                "data-toggle": "collapse",
                "data-target": "#myAccountMenu",
                "aria-expanded": "false",
                "aria-label": _vm.myAccountTitle,
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-user hAccIcon",
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fal",
                    "data-icon": "user",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hAccTexts d-none d-lg-inline" }, [
                _c("div", { staticClass: "hProfile" }, [
                  _vm._v(_vm._s(_vm.myAccountTitle)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hIdent small" }, [
                  _vm._v(_vm._s(_vm.myAccountSubTitle)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-angle-down",
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fal",
                    "data-icon": "angle-down",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 384 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M362.7 203.9l-159.1 144c-6.125 5.469-15.31 5.469-21.44 0L21.29 203.9C14.73 197.1 14.2 187.9 20.1 181.3C26.38 174.4 36.5 174.5 42.73 180.1L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188C369.8 187.9 369.3 197.1 362.7 203.9z",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c(
            "div",
            {
              staticClass: "hAcc collapsed",
              attrs: {
                role: "button",
                "data-toggle": "collapse",
                "data-target": "#myAccountMenu",
                "aria-expanded": "false",
                "aria-label": _vm.myAccountTitle,
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-user hAccIcon",
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fal",
                    "data-icon": "user",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hAccUsername d-none d-lg-inline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginHello", {
                      username: _vm.username,
                    })
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-angle-down",
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fal",
                    "data-icon": "angle-down",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 384 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M362.7 203.9l-159.1 144c-6.125 5.469-15.31 5.469-21.44 0L21.29 203.9C14.73 197.1 14.2 187.9 20.1 181.3C26.38 174.4 36.5 174.5 42.73 180.1L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188C369.8 187.9 369.3 197.1 362.7 203.9z",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c(
          "div",
          {
            ref: "collapse",
            staticClass: "collapse",
            attrs: { id: "myAccountMenu" },
          },
          [
            _c(
              "div",
              { staticClass: "collapse-inner list-group" },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      "data-testing": "login-select",
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "d-inline" }, [
                      _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
                    ]),
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginCallToAction")
                    ) +
                    "\n            "
                ),
                _c(
                  "a",
                  {
                    staticClass: "register-link",
                    attrs: {
                      "data-testing": "register-select",
                      href: _vm.isRegister
                        ? "javascript:void(0)"
                        : "#registration",
                      "data-toggle": _vm.isRegister ? false : "modal",
                      "aria-label": _vm.$translate(
                        "Ceres::Template.loginRegister"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        _vm.createRegisterModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "d-inline" }, [
                      _vm._v(
                        _vm._s(_vm.$translate("Ceres::Template.regRegister"))
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm._t("global-myAccount-links"),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn
      ? _c(
          "div",
          {
            ref: "collapse",
            staticClass: "collapse",
            attrs: { id: "myAccountMenu" },
          },
          [
            _c(
              "div",
              { staticClass: "collapse-inner list-group isLoggedIn" },
              [
                _c(
                  "div",
                  { staticClass: "d-inline d-lg-none hAccUsername-link" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.loginHello", {
                          username: _vm.username,
                        })
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "myAccount-links" }, [
                  _c(
                    "a",
                    {
                      staticClass: "list-group-item small",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "svg-inline--fa fa-user hAccIcon",
                          attrs: {
                            "aria-hidden": "true",
                            focusable: "false",
                            "data-prefix": "fal",
                            "data-icon": "user",
                            role: "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        " \n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._t("global-myAccount-links"),
                _vm._v(" "),
                _vm._t("loggedIn-myAccount-links"),
                _vm._v(" "),
                _c("div", { staticClass: "myAccount-links" }, [
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      staticClass: "list-group-item small",
                      attrs: { href: "#" },
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }